var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm._l(_vm.databases, function(database) {
        return _c(
          "div",
          {
            key: database
          },
          [
            _vm._v(" " + _vm._s(database) + " "),
            _c(
              "v-tooltip",
              {
                attrs: {
                  bottom: ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function fn(_ref) {
                        var on = _ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: {
                                  small: "",
                                  icon: "",
                                  text: "",
                                  color: "primary"
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.revokePrivileges(database)
                                  }
                                }
                              },
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-delete")])],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              },
              [_c("span", [_vm._v("Revoke Privileges")])]
            )
          ],
          1
        )
      }),
      _c("revoke-user-modal", {
        attrs: {
          opened: _vm.revokeModal,
          user: _vm.user,
          database: _vm.selectedDatabase
        },
        on: {
          "action-completed": function actionCompleted($event) {
            return _vm.$emit("action-completed")
          },
          close: _vm.closeRevokeModal
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }